import '../App.css';
import HomeHero from '../components/HomeHero';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet";

function Home() {

  return (
    <>
      <Helmet>
        <title>AbbVie Vraie Vie</title>
        <meta
          name="description"
          content="Portail ATU, RTU, Etudes"
        />
      </Helmet>
      <HomeHero/>
      <div className='abbvie-container no-background'>
        <div className="medium-container">
          <div className='flex2'>
            <h2>Faciliter l'accès des patients aux <strong>innovations thérapeutiques</strong></h2>
          </div>
          <div className='flex3'>
            <p>
              L'innovation thérapeutique n'a de valeur que si elle est disponible pour tous, partout et dans les meilleurs délais. C'est pourquoi chez AbbVie, nous nous mobilisons pour accélérer le développement et la mise à disposition des innovations thérapeutiques. Le portail Vraie Vie regroupe les accès à certaines catégories de projets " Real World Evidence" menés par la Filiale France AbbVie. <br/>
              Ces projets incluent les AP (Accès Précoces), les AC (Accès Compassionnels), les CPC (Cadres de Prescription Compassionnelle) et les RUSD (Recherches avec Utilisation Secondaire des Données)
            </p>
          </div>
        </div>
      </div>
      <div className='abbvie-container abbvie-container-footer'>
        <div className="medium-container">
          <div className='flex1'></div>
          <div className='flex1 bloc-container'>
            <p>LIENS DIRECTS</p>
            <div className='flex'>
              <div className='flex1'>
                <h3>Les accès aux innovations thérapeutiques</h3>
              </div>
              <div className='flex1'>
                <ul>
                  <li><Link to={'/nos-ap'}>Accès précoces (AP)</Link></li>
                  <li><Link to={'/nos-ac'}>Accès compassionnels (AC)</Link></li>
                  <li><Link to={'/nos-cpc'}>Cadre de prescription compassionnelle (CPC)</Link></li>
                  <li><Link to={'/nos-rusd'}>Recherche avec utilisation secondaire des données (RUSD)</Link></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
   )
}

export default Home;
